import type { CreateUpdateSlideModel, ShareSlideModel, SlideDetailsModel, SlideModel, UpdateSlideStatusItemModel, UpdateSlidesSortOrderItemModel } from './model/merchModel'
import type SharedFolder from '@/models/sharedFolder'
import Net from '@/services/net'

export function getMySlides(catalogCode: number) {
  return Net.t1.get<SlideModel[]>(`/catalogs/${catalogCode}/mymerchslides?slideType=my&version=0`)
}

export function getSlideDetails(catalogCode: number, slideId: string) {
  return Net.t1.get<SlideDetailsModel>(`/catalogs/${catalogCode}/merchSlides/${slideId}`)
}

export function createUpdateMerchSlide(catalogCode: number, requestObject: CreateUpdateSlideModel) {
  return Net.t1.put<SlideModel>(`/catalogs/${catalogCode}/merchslides`, requestObject)
}

export function updateSlidesSortOrders(catalogCode: number, requestObject: UpdateSlidesSortOrderItemModel[]) {
  return Net.t1.put(`/catalogs/${catalogCode}/merchslides/sortorder`, requestObject)
}

export function getSharedSlides(catalogCode: number) {
  return Net.t1.get<SlideModel[]>(`/catalogs/${catalogCode}/mymerchslides?slideType=shared`)
}

export function getSharedFolders(catalogCode: number) {
  return Net.t1.get<SharedFolder[]>(`/catalogs/${catalogCode}/sharingfolders?entity=merch`)
}

export function shareSlide(catalogCode: number, requestObject: ShareSlideModel) {
  return Net.t1.put<string>(`/catalogs/${catalogCode}/merchslides/share`, requestObject)
}
export function updateSlideStatus(catalogCode: number, requestObject: UpdateSlideStatusItemModel[]) {
  return Net.t1.put<string>(`/catalogs/${catalogCode}/merchslides/status`, requestObject)
}
